module.exports = __webpack_public_path__ + "img/working.c8e476a3.png";